module.exports = __webpack_public_path__ + "static/media/activity.21a5c783.svg";